import { getQueryParams } from "fe-common/useQueryParams";
import { usePatient } from "../state/patientContext";
import { useEffect } from "react";
import { useDaoContext } from "fe-web-components/diseaseview/DaoContext";

let copySent = false;
export function useAutoSave(clinicId: string) {
  const dao = useDaoContext();
  const { setMasterLoading } = usePatient();

  useEffect(() => {
    const queryParams = getQueryParams();
    const caseId = queryParams.get("patientCaseId");
    const src = queryParams.get("ksrc");
    if (
      !copySent &&
      caseId &&
      window &&
      !src?.toLowerCase().includes("patient")
    ) {
      setMasterLoading(true);
      copySent = true;
      dao.copyPatientCase(caseId, clinicId).then((copiedCaseId) => {
        queryParams.delete("autosave");
        queryParams.delete("patientCaseId");
        queryParams.set("ksrc", "patient_copy");
        queryParams.set("patientCaseId", copiedCaseId);
        window.location.search = queryParams.toString();
      });
    }
  }, [dao, setMasterLoading, clinicId]);
}
